export enum BrandPageModal {
  CONTACT_MAKER = "CONTACT_MAKER",
  RESUME_INSIDER = "RESUME_INSIDER",
  STORY = "STORY",
  ZIPCODE_PROTECTED = "ZIPCODE_PROTECTED",
  RESTRICTED = "RESTRICTED",
  UPDATE_CART = "UPDATE_CART",
  SAMPLE_REQUEST = "SAMPLE_REQUEST",
  SHARE_CONTACT_INFO = "SHARE_CONTACT_INFO",
  REQUEST_EXCLUSIVITY = "REQUEST_EXCLUSIVITY",
}
